import { render, staticRenderFns } from "./WorkRequestCard.vue?vue&type=template&id=74f00017"
import script from "./WorkRequestCard.js?vue&type=script&lang=js&external"
export * from "./WorkRequestCard.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports